export const obfuscateEmail = (email: string, visibleLength = 5) => {
  const [name, domain] = email.split('@');
  const obfuscatedLocalPart = '*'.repeat(8);

  const visibleName = name.slice(0, visibleLength);

  return `${visibleName}${obfuscatedLocalPart}@${domain}`;
};
